import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Transition = styled(ReactCSSTransitionGroup)`
  .bottom-fade-enter {
    & > div {
      bottom: -100%;
    }
  }

  .bottom-fade-enter.bottom-fade-enter-active {
    & > div {
      bottom: 0;
      transition: bottom 0.5s;
    }
  }

  .bottom-fade-leave {
    & > div {
      bottom: 0;
    }
  }

  .bottom-fade-leave.bottom-fade-leave-active {
    & > div {
      bottom: -100%;
      transition: bottom 0.5s;
    }
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  overflow: hidden;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background-color: ${({ theme }) => theme.bottomSheet.backdrop};
`;

interface ModalType {
  ios: boolean;
  noScroll: boolean;
}

export const Modal: any = styled.div.attrs<any, ModalType>((): any => ({}))`
  position: absolute;
  overflow: ${({ noScroll }) => (noScroll ? 'hidden' : 'auto')};
  max-height: 95%;
  background-color: ${({ theme }) => theme.bottomSheet.background};
  width: 100%;
  border-radius: 15px 15px 0 0;
  margin-top: 1px;
  bottom: 0;
  padding-bottom: ${({ ios }) => (ios ? '130px' : '0px')};
`;

Modal.Header = styled.div`
  text-align: center;
  border-bottom: solid 1px ${({ theme }) => theme.bottomSheet.headerBorder};
`;

Modal.Header.Dragger = styled.div`
  width: 100%;
  padding-top: 5px;
  padding-bottom: 16px;
  cursor: pointer;

  &:after {
    content: ' ';
    display: block;
    margin: 0 auto;
    width: 37px;
    height: 5px;
    border-radius: 3px;
    background-color: ${({ theme }) => theme.bottomSheet.draggerBackground};
  }
`;

Modal.Header.Title = styled.div`
  padding: 6px 16px 24px 16px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: -0.4px;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.bottomSheet.titleColor};
  &.highlight {
    background: ${({ theme }) => theme.button.background};
    padding: 16px;
    color: ${ColorPalette.HEX.White};
    font-weight: 600;
  }
`;

interface ModalBodyStyledProps {
  styledProps: {
    noPadding: boolean;
  };
}

Modal.Body = styled(({ styledProps, ...rest }: ModalBodyStyledProps) => <div {...rest} />)`
  ${({ styledProps }) => {
    if (!styledProps.noPadding) {
      return 'padding: 16px 16px 32px 16px';
    }
  }}
`;
